import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../environments/environment';

/**
 * Hängt das Cognito-ACCESS-Token als Bearer an alle Requests an UNSER Backend
 * (REST unter API_Base + HotChocolate-GraphQL, dessen HttpLink über Angulars
 * HttpClient läuft). Der URL-Präfix-Guard hält den Header bewusst fern von:
 *  - S3-presigned PUT/GET (SigV4 lehnt einen zusätzlichen Authorization-Header ab),
 *  - AppSync (eigene x-api-key-Auth).
 * Gegenstück im Backend: AddJwtAuthentication (RoleClaimType cognito:groups).
 */
export const authTokenInterceptor: HttpInterceptorFn = (req, next) => {
  if (
    req.url.startsWith(environment.API_Base) ||
    req.url.startsWith(environment.backendGraphQLUrl)
  ) {
    const token = inject(OAuthService).getAccessToken();
    if (token) {
      req = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
    }
  }
  return next(req);
};
